import Vue from 'vue'
import VueRouter from 'vue-router'
// import Login from '../views/Login.vue'
import Index from '../views/Index.vue'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  // {
  //   path: '/',
  //   name: 'Login',
  //   component: Login
  // },
  {
    path: '/',
    name: 'pooway',
    component: Index,
    redirect: '/Home',
    children: [
      {
        path: '/Home',
        name: 'Home',
        component: () => import('../views/home/Home.vue')
      },
      {
        path: '/GoodsDetails',
        name: 'GoodsDetails',
        component: () => import('../views/details/GoodsDetails.vue')
      },
      {
        path: '/GoodsPlay',
        name: 'GoodsPlay',
        component: () => import('../views/details/GoodsPlay.vue')
      },
      {
        path: '/MyCourse',
        name: 'MyCourse',
        component: () => import('../views/details/MyCourse.vue')
      }
    ]
  },
  {
    path: '/ArticleDetails',
    name: 'ArticleDetails',
    component: () => import('../views/details/ArticleDetails.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
